import { useCatalogsStore } from '@/store/catalogs';


export const catalogsOptions = {
    activityTypesFromStore: (params = {}) => {
        const catalogsStore = useCatalogsStore();
        const activity_types = catalogsStore.catalogs.find(c => c.name === 'Tipos de Actividad')?.items || []
        return Promise.resolve(activity_types);
    },
    originsFromStore: (params = {}) => {
        const catalogsStore = useCatalogsStore();
        const origins = catalogsStore.catalogs.find(c => c.name === 'Canales de Llegada')?.items || []
        return Promise.resolve(origins);
    },
    expenseTypesFromStore: (params = {}) => {
        const catalogsStore = useCatalogsStore();
        const expense_types = catalogsStore.catalogs.find(c => c.name === 'Conceptos de Gasto')?.items || []
        return Promise.resolve(expense_types);
    },
    influencerCategoriesFromStore: (params = {}) => {
        const catalogsStore = useCatalogsStore();
        const influencer_categories = catalogsStore.catalogs.find(c => c.name === 'Categorías de Influencer')?.items || []
        return Promise.resolve(influencer_categories);
    },
};
